import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { NotificationsProvider } from '@rad/contexts/notifications';
import './ui/scss/main.scss';
import Root from './ui/root.internal';
import ConnectorIntuitResult from './ui/_connectors/intuit/result';
sessionStorage.removeItem('unsaved');
const App = window.location.hash.startsWith('#/connectors/intuit') ? ConnectorIntuitResult : Root;
createRoot(document.getElementById('root')).render(__DEV__
    ? _jsx(_Fragment, { children: _jsx(StrictMode, { children: _jsx(NotificationsProvider, { children: _jsx(App, {}) }) }) })
    : _jsx(_Fragment, { children: _jsx(NotificationsProvider, { children: _jsx(App, {}) }) }));
